<template>
  <div class="StationCardContainer">
    <nut-swiper :is-stop-propagation="false"
                  v-if="data?.station?.dataUrls"
                  :is-prevent-default="false" :pagination-visible="false"
                  pagination-color="#426543" auto-play="3000">
        <nut-swiper-item v-for="(m,mi) in data?.station?.dataUrls"
                         @click="playVideo(m)"
                         :key="mi" style="height: 120px;width: 100%;">
          <img v-if="m.endsWith('mp4')" :src="`${m}?x-oss-process=video/snapshot,t_1000,m_fast`"
               style="height: 100%; width: 100%"/>
          <img v-else :src="m"
               style="height: 100%; width: 100%"/>
        </nut-swiper-item>
      </nut-swiper>
      <div class="videoCover bothCenter" v-else>
        <img src="https://cdn.waityou.online/cf83afbe-b7c6-a20f-2cf3-457902fcf037.png"/>
      </div>
      <nut-row class="stationNumbers " type="flex" justify="space-between">
        <nut-col :span="8" style="text-align: left;">
          <span>参观人次:{{ data?.station?.visitPeopleCount }}</span>
        </nut-col>
        <nut-col :span="8"  style="text-align: center;">
          <span>参观次数:{{ data?.station?.visitCount }}</span>
        </nut-col>
        <nut-col :span="8"  style="text-align: right;">
          <span>浏览数:{{ data?.station?.browseCount }}</span>
        </nut-col>
      </nut-row>
      <nut-row class="leftCenter mb8 stationNumber">
        <span class="mr8">评价指数</span>
        <nut-rate active-color="orange" icon-size="12"
                  checked-icon="https://cdn.waityou.online/a7daaf55-aeae-d157-9eb6-e9554fdeb5f7.png"
                  unchecked-icon="https://cdn.waityou.online/6caf8edf-e720-47fa-8652-976426ee5b62.png"
                  readonly
                  v-model="avgScore"/>
      </nut-row>
      <div>
        <div class="stationNumber">
          <span class="evaluate">{{ evaluate.name }}</span>
        </div>
        <div class="commentContainer">
          <InfiniteLoadingList ref="InfiniteLoadingList" query-id="2" :initQuery="evaluateQuery">
            <template v-slot="data">
              <nut-row class="comment">
                <nut-col :span="4" class="leftCenter">
                  <img class="avatar" :src="data.data.userAvatar"/>
                </nut-col>
                <nut-col :span="22" class="colFlex">
                  <span class="nickName">{{ data.data.userName }}</span>
                  <nut-ellipsis
                      class="content"
                      direction="end"
                      :rows="2"
                      expandText="展开"
                      collapseText="收起"
                      :content="data.data.content"></nut-ellipsis>
                  <span class="postTime">{{ data.data.createdTime }}</span>
                  <nut-row>
                    <img v-for="(img,imgIndex) in data.data.imgs" :key="imgIndex"
                         @click="previewImage(data.data.imgs)"
                         :src="img" style="width: 80px;height: 80px;object-fit: cover;margin-right: 8px;"/>
                  </nut-row>
                  <div class="divider"></div>
                </nut-col>
              </nut-row>
            </template>
          </InfiniteLoadingList>
        </div>
      </div>
  </div>
</template>

<script>
import {Toast} from "@nutui/nutui";
import InfiniteLoadingList from "@/components/InfiniteLoadingListCopy"
export default {
  name: "StationCard",
  components: {InfiniteLoadingList},
  props: {
    myLocation: {
      type: Object,
      default: () => {
        return null
      }
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    menus: {
      type: Array,
      default: () => {
        return []
      }
    },
    actionBtn: {
      type: String,
      default: '约参观'
    },
    empty: {
      type: Boolean,
      default: false,
    },
    evaluate: {
      type: Object,
      default: () => {
        return {
          type: 'STATION_VISIT',
          id: 0,
          name: '参观评价'
        }
      }
    },
  },
  watch: {
    data(){
        this.init()
    }
  },
  data() {
    return {
      avgScore: 5,
      evaluateQuery: {
        type: this.evaluate.type,
        id:null
      }
    }
  },
  methods: {
    openCommit(id){
      this.$nextTick(()=>{
        this.$refs.InfiniteLoadingList.open(id)
      })
    },
    goNavigation() {
      if (!this.myLocation) {
        Toast.warn('请注意您的定位可能不准确')
      }
      // eslint-disable-next-line no-undef
      ZWJSBridge.openLink({
        url: `zwfw://openThirdMap?longitude=${this.data.station.longitude}&latitude=${this.data.station.latitude}&locationName=${this.data.station.name}`
      }).then((result) => {
        console.log(result);
      }).catch((error) => {
        console.log(error);
      })
      // window.open(`https://uri.amap.com/navigation?to=${this.data.station.longitude},${this.data.station.latitude},${this.data.station.name}&mode=car&policy=&src=xfbm&coordinate=gaode&callnative=1`)
    },
    onIconClick(icon) {
      if (icon.stationLink) {
        this.$router.push(icon.link + this.data.station.id)
      } else {
        this.$router.push(icon.link)
      }
    },
    calDistance() {
      if (!this.myLocation) {
        return '未知'
      }
      // eslint-disable-next-line no-undef
      return parseInt(AMap.GeometryUtil.distance(this.myLocation,
          // eslint-disable-next-line no-undef
          new AMap.LngLat(this.data.station.longitude, this.data.station.latitude))) + '米'
    },
    init() {
      if(!this.empty){
        this.avgScore = this.data.station.avgScore;
      }
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.StationCardContainer {
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: 16px;
  // margin: 16px auto 16px;
  padding: 15px 10px 10px;
  width: 85vw;

  .divider {
    background-color: #DEEDFF;
    height: 1px;
    width: 100%;
    margin-bottom: 8px;
  }

  .btn1 {
    color: #2F438C;
    background: rgba(0, 100, 255, 0.1);
    border-radius: 8px;
    border: none;
    width: 90%;
    text-align: center;
    line-height: 38px;
  }

  .btn2 {
    color: white;
    background: #2F438C;
    border-radius: 8px;
    border: none;
    width: 90%;
    text-align: center;
    line-height: 38px;
  }

  .stationFunction {
    display: flex;
    flex-direction: column;

    img {
      width: 24px;
      height: 24px;
    }

    span {
      font-size: $minFontSize;
    }

  }

  .reputation {
    background-color: #F2F2F2;
    border-radius: 16px;
    height: 32px;
    margin: 8px 0;

    img {
      width: 13.75px;
      height: 16px;
    }

    span {
      margin: 4px;
      font-size: $miniFontSize;
    }
  }

  .address {
    font-size: $miniFontSize;
  }

  .stationName {
    font-size: $baseFontSize;
  }

  .pinTag {
    font-size: $minFontSize;
    color: #2FC25B;
    background-color: rgba(222, 237, 255, 0.5);
    padding: 1px;
    border-radius: 2px;
    margin-left: 6px;
  }

  .distance {
    font-size: $miniFontSize;
    color: #2F438C;
    margin-right: 6px;
  }
}
.stationNumbers {
  font-size: $minFontSize;
  color: #999999;
  padding: 6px 0 2px;
  width: 96%;
  margin: 0 auto;
}
.stationNumber{
  font-size: $miniFontSize;
  color: #999999;
  padding: 2px 0;
  width: 96%;
  margin: 0 auto;
  .evaluate{ 
    color: #888888;
    font-weight: bold;
  }
}
.commentContainer {
    max-height: 130px;
    overflow-y: scroll;
    scrollbar-width: thin; /* 创建一个细的滚动条，适用于某些浏览器 */
    scrollbar-color: transparent transparent; /* 设置滚动条的颜色为透明，适用于某些浏览器 */

    .comment {
      padding: 8px 0;
      display: flex;
      flex-direction: row;

      .avatar {
        width: 40px;
        height: 40px;
        border-radius: 20px;
      }

      .nickName {
        color: #999999;
        font-size: $miniFontSize;

      }

      .content {
        font-size: $miniFontSize;
      }

      .postTime {
        color: #999999;
        font-size: $minFontSize;
      }
    }
  }

  .commentContainer::-webkit-scrollbar {
    width: 0.5em; /* 设置滚动条的宽度，适用于 Chrome、Safari 和 Opera */
  }

  .commentContainer::-webkit-scrollbar-track {
    background-color: transparent; /* 设置滚动条的背景颜色为透明，适用于 Chrome、Safari 和 Opera */
  }

  .commentContainer::-webkit-scrollbar-thumb {
    background-color: transparent; /* 设置滚动条的滑块颜色为透明，适用于 Chrome、Safari 和 Opera */
  }
</style>